<mat-form-field style="width: 100%; min-width: 800px">
    <mat-label>Betriebsart</mat-label>
    <mat-select
        [required]="required"
        [compareWith]="betriebsartComparator"
        [formControl]="betriebsartCtrl"
        (selectionChange)="betriebsartChanged($event)"
    >
        <mat-option>Keine</mat-option>
        <mat-option *ngFor="let b of betriebsarten" [value]="b">{{ b.bezeichnung }}</mat-option>
    </mat-select>
</mat-form-field>
